import styled from 'styled-components'
import { theme } from '../../styles/theme'

export const Container = styled.div`
  position: relative;

  display: flex;
  justify-content: center;

  &:hover > div {
    display: flex !important;
  }
`

export const Wrapper = styled.div`
  position: absolute;
  top: -45px;

  padding: 4px 14px;

  background: #fff;
  border-radius:  ${theme.border.mediumRadius};
  box-shadow: 0px 7px 20px rgba(187, 192, 205, 0.4);
  font-family: ${theme.font.workSans};
  font-size: ${theme.font.sizes.normal};
  line-height: ${theme.font.sizes.medium};

  display: none;
  justify-content: center;
`

export const Arrow = styled.div`
  width: 0;
  height: 0;

  position: absolute;
  bottom: -13px;

  border-radius:  ${theme.border.xsmallRadius};
  box-shadow: 0px 7px 20px rgba(187, 192, 205, 0.4);
  border: 13px solid transparent;
  border-top: 13px solid ${theme.colors.mainBg};
  border-bottom: 0;
`
